import { formatJalaliDisplay, toFaDigits } from './jalali';

const TEHRAN = 'Asia/Tehran';

export function tehranIsoDate(value: string | Date): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TEHRAN }).format(new Date(value));
}

export function formatFlightTime(value: string | Date, locale: string): string {
  return new Date(value).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TEHRAN,
  });
}

export function formatFlightDate(value: string | Date, isFa: boolean): string {
  return formatJalaliDisplay(tehranIsoDate(value), isFa);
}

export function formatIsoDate(iso: string, isFa: boolean): string {
  return formatJalaliDisplay(iso.slice(0, 10), isFa);
}

export function formatMoney(amount: number, currency: string, isFa: boolean): string {
  const unit = currency === 'IRR' && isFa ? 'ریال' : currency;
  const value = amount.toLocaleString('en-US');
  return `${isFa ? toFaDigits(value) : value} ${unit}`;
}
